import React, { useRef } from "react";
import "./NewPreviewUI.css";
import { useDispatch, useSelector } from "react-redux";

const BackgroundImageController = ({
  zoomLevel,
  setzoomLevel,
  setimageLeft,
  imageLeft,
  setimageTop,
  imageTop,
  setimageRight,
  imageRight,
  setimageBottom,
  imageBottom,
  setDisplayProperty
}) => {
  const dispatch = useDispatch();
  const previewData = useSelector((state) => state.preview.previewObject);
  const intervalRef = useRef(null);

  const handleLeftClick = () => {
    setimageLeft(imageLeft - 1);
    setimageRight(imageRight + 1);
  };
  const handleRightClick = () => {
    setimageRight(imageRight - 1);
    setimageLeft(imageLeft + 1);
  };
  const handleTopClick = () => {
    setimageTop(imageTop - 1);
    setimageBottom(imageBottom + 1);
  };
  const handleBottomClick = () => {
    setimageBottom(imageBottom - 1);
    setimageTop(imageTop + 1);
  };

  const handleMouseDown = (direction) => {
    intervalRef.current = setInterval(() => {
      switch (direction) {
        case "left":
          setimageLeft((prevLeft) => prevLeft - 1);
          setimageRight((prevRight) => prevRight + 1);
          break;
        case "right":
          setimageRight((prevRight) => prevRight - 1);
          setimageLeft((prevLeft) => prevLeft + 1);
          break;
        case "top":
          setimageTop((prevTop) => prevTop - 1);
          setimageBottom((prevBottom) => prevBottom + 1);
          break;
        case "bottom":
          setimageBottom((prevBottom) => prevBottom - 1);
          setimageTop((prevTop) => prevTop + 1);
          break;
        default:
          break;
      }
    }, 100);
  };

  const handleMouseUp = () => {
    clearInterval(intervalRef.current);
  };
  const handleZoomInClick = () => {
    setzoomLevel(zoomLevel * 1.05);
  };
  const handleZoomOutClick = () => {
    setzoomLevel(zoomLevel * 0.95);
  };
  const handleFitHeightClick = () => {
    setzoomLevel(1);
    setimageBottom(0);
    setimageTop(0);
    setDisplayProperty("Height");
  };
  const handleFitWidthClick = () => {
    setzoomLevel(1);
    setimageLeft(0);
    setimageRight(0);
    setDisplayProperty("Width");
  };
  return (
    <div className="backgroundImageController">
      <div className="backgroundImageLeftController">
        <div className="backgroundImageLeftControllerTopArrowContain">
          <div
            className="backgroundImageLeftControllerTopArrow"
            onClick={handleTopClick}
            onMouseDown={() => handleMouseDown("top")}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            <svg width="10" height="11" viewBox="0 0 10 11" fill="none">
              <rect
                x="0.0952148"
                y="0.428711"
                width="9.90476"
                height="9.90476"
                fill="url(#pattern0_1370_289)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_289"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_289"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_289"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqklEQVR4nO3bPYsTQRwG8BFfz0KwVdHKRss0KwSXeZ4ptghYbaGNL1/Ar2ChIL711ylcYa3VfQSxuE6LK09OjIpgISl8YyCBEBKyyc5mZ3efHwyEkOzM/pOdmWdzZ4yIiIiIiIiIiIiIiIiIiIiISAlJkmyRfApg6Jt/7J8rc0yZ4Zw7R/IdyX/TDcCetfbS7OtlDc65BMDhbJGnij10zqXrHFvGrLU3Sf5aVOSpYo9I3pu8TwrK8/woycfLCjyn4Nu9Xu940X46LcuyMyTfrFrkqbbb7/fP1n0eUXPOXQbwoUSRJ23fWnu17vOJEsmM5I8ARZ60nyRv1H1eUQFwH8DvgEWetL8kHxhjjpguy7LsJICXFRR4dpF8PRgMTpsucgtCSIXF7l64cUtCSIXF7k64IXl7HDDWLdYf30q8fwTgjmmrfM0QMm8nEWKH0spwk5UPIb7tA7gys+f+WPKY7Qk3gULI7ryC+A8QwFt2Pdxs4hLPA05JposhBCvekXPO3Spyp6814SZECAEwtNZer2Pb2IhwEyKEANhzzl2sewzRhpuYvk1ZoKsqunBT9JcQbnh+3PQ6UZkmrPhseripIoRUpbHhpsoQUpXGhZsmX4p5A6a6Vi0uLtZwk6bpMQA7Jb/Fh34LaCJB8lqA7eiOr03IQT0qOaD3AM6byKRpesGPreRU8jDYgEgetDXSpml6CsCrEoX+FGwwUc1jEa4/wQbRlduOXHNHFXIA0YWQmMJNsM679tNQtmK4CdZxwUVvO+hWp2arhJtgnS4p8Mhae9e0lCsQboJ1BuBbE0JIleGG5OcFhf4arCMAz5sSQjYdbgA8CdZJnucnALzwnyqA777wXfyPqCRJtnwdxjX4QvJZ6/4IR0RERERERERERERERERERERERMwS/wGXExjFUxBvVgAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg>
          </div>
        </div>
        <div className="backgroundImageLeftControllerLeftRightArrow">
          <div
            className="backgroundImageLeftControllerLeftArrow"
            onMouseDown={() => handleMouseDown("left")}
            onClick={handleLeftClick}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            <svg width="10" height="11" viewBox="0 0 10 11" fill="none">
              <rect
                y="10.667"
                width="9.90476"
                height="9.90476"
                transform="rotate(-90 0 10.667)"
                fill="url(#pattern0_1370_290)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_290"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_290"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_290"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqklEQVR4nO3bPYsTQRwG8BFfz0KwVdHKRss0KwSXeZ4ptghYbaGNL1/Ar2ChIL711ylcYa3VfQSxuE6LK09OjIpgISl8YyCBEBKyyc5mZ3efHwyEkOzM/pOdmWdzZ4yIiIiIiIiIiIiIiIiIiIiISAlJkmyRfApg6Jt/7J8rc0yZ4Zw7R/IdyX/TDcCetfbS7OtlDc65BMDhbJGnij10zqXrHFvGrLU3Sf5aVOSpYo9I3pu8TwrK8/woycfLCjyn4Nu9Xu940X46LcuyMyTfrFrkqbbb7/fP1n0eUXPOXQbwoUSRJ23fWnu17vOJEsmM5I8ARZ60nyRv1H1eUQFwH8DvgEWetL8kHxhjjpguy7LsJICXFRR4dpF8PRgMTpsucgtCSIXF7l64cUtCSIXF7k64IXl7HDDWLdYf30q8fwTgjmmrfM0QMm8nEWKH0spwk5UPIb7tA7gys+f+WPKY7Qk3gULI7ryC+A8QwFt2Pdxs4hLPA05JposhBCvekXPO3Spyp6814SZECAEwtNZer2Pb2IhwEyKEANhzzl2sewzRhpuYvk1ZoKsqunBT9JcQbnh+3PQ6UZkmrPhseripIoRUpbHhpsoQUpXGhZsmX4p5A6a6Vi0uLtZwk6bpMQA7Jb/Fh34LaCJB8lqA7eiOr03IQT0qOaD3AM6byKRpesGPreRU8jDYgEgetDXSpml6CsCrEoX+FGwwUc1jEa4/wQbRlduOXHNHFXIA0YWQmMJNsM679tNQtmK4CdZxwUVvO+hWp2arhJtgnS4p8Mhae9e0lCsQboJ1BuBbE0JIleGG5OcFhf4arCMAz5sSQjYdbgA8CdZJnucnALzwnyqA777wXfyPqCRJtnwdxjX4QvJZ6/4IR0RERERERERERERERERERERERMwS/wGXExjFUxBvVgAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg>
          </div>
          <div
            className="backgroundImageLeftControllerRightArrow"
            onMouseDown={() => handleMouseDown("right")}
            onClick={handleRightClick}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
          >
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <rect
                x="10.0952"
                y="0.761719"
                width="9.90476"
                height="9.90476"
                transform="rotate(90 10.0952 0.761719)"
                fill="url(#pattern0_1370_291)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_291"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_291"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_291"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqklEQVR4nO3bPYsTQRwG8BFfz0KwVdHKRss0KwSXeZ4ptghYbaGNL1/Ar2ChIL711ylcYa3VfQSxuE6LK09OjIpgISl8YyCBEBKyyc5mZ3efHwyEkOzM/pOdmWdzZ4yIiIiIiIiIiIiIiIiIiIiISAlJkmyRfApg6Jt/7J8rc0yZ4Zw7R/IdyX/TDcCetfbS7OtlDc65BMDhbJGnij10zqXrHFvGrLU3Sf5aVOSpYo9I3pu8TwrK8/woycfLCjyn4Nu9Xu940X46LcuyMyTfrFrkqbbb7/fP1n0eUXPOXQbwoUSRJ23fWnu17vOJEsmM5I8ARZ60nyRv1H1eUQFwH8DvgEWetL8kHxhjjpguy7LsJICXFRR4dpF8PRgMTpsucgtCSIXF7l64cUtCSIXF7k64IXl7HDDWLdYf30q8fwTgjmmrfM0QMm8nEWKH0spwk5UPIb7tA7gys+f+WPKY7Qk3gULI7ryC+A8QwFt2Pdxs4hLPA05JposhBCvekXPO3Spyp6814SZECAEwtNZer2Pb2IhwEyKEANhzzl2sewzRhpuYvk1ZoKsqunBT9JcQbnh+3PQ6UZkmrPhseripIoRUpbHhpsoQUpXGhZsmX4p5A6a6Vi0uLtZwk6bpMQA7Jb/Fh34LaCJB8lqA7eiOr03IQT0qOaD3AM6byKRpesGPreRU8jDYgEgetDXSpml6CsCrEoX+FGwwUc1jEa4/wQbRlduOXHNHFXIA0YWQmMJNsM679tNQtmK4CdZxwUVvO+hWp2arhJtgnS4p8Mhae9e0lCsQboJ1BuBbE0JIleGG5OcFhf4arCMAz5sSQjYdbgA8CdZJnucnALzwnyqA777wXfyPqCRJtnwdxjX4QvJZ6/4IR0RERERERERERERERERERERERMwS/wGXExjFUxBvVgAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg>
          </div>
        </div>
        <div className="backgroundImageLeftControllerBottomArrowContainer">
          <div
            className="backgroundImageLeftControllerBottomArrow"
            onMouseDown={() => handleMouseDown("bottom")}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onClick={handleBottomClick}
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <rect
                x="10"
                y="10"
                width="9.90476"
                height="9.90476"
                transform="rotate(180 10 10)"
                fill="url(#pattern0_1370_292)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_292"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_292"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_292"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqklEQVR4nO3bPYsTQRwG8BFfz0KwVdHKRss0KwSXeZ4ptghYbaGNL1/Ar2ChIL711ylcYa3VfQSxuE6LK09OjIpgISl8YyCBEBKyyc5mZ3efHwyEkOzM/pOdmWdzZ4yIiIiIiIiIiIiIiIiIiIiISAlJkmyRfApg6Jt/7J8rc0yZ4Zw7R/IdyX/TDcCetfbS7OtlDc65BMDhbJGnij10zqXrHFvGrLU3Sf5aVOSpYo9I3pu8TwrK8/woycfLCjyn4Nu9Xu940X46LcuyMyTfrFrkqbbb7/fP1n0eUXPOXQbwoUSRJ23fWnu17vOJEsmM5I8ARZ60nyRv1H1eUQFwH8DvgEWetL8kHxhjjpguy7LsJICXFRR4dpF8PRgMTpsucgtCSIXF7l64cUtCSIXF7k64IXl7HDDWLdYf30q8fwTgjmmrfM0QMm8nEWKH0spwk5UPIb7tA7gys+f+WPKY7Qk3gULI7ryC+A8QwFt2Pdxs4hLPA05JposhBCvekXPO3Spyp6814SZECAEwtNZer2Pb2IhwEyKEANhzzl2sewzRhpuYvk1ZoKsqunBT9JcQbnh+3PQ6UZkmrPhseripIoRUpbHhpsoQUpXGhZsmX4p5A6a6Vi0uLtZwk6bpMQA7Jb/Fh34LaCJB8lqA7eiOr03IQT0qOaD3AM6byKRpesGPreRU8jDYgEgetDXSpml6CsCrEoX+FGwwUc1jEa4/wQbRlduOXHNHFXIA0YWQmMJNsM679tNQtmK4CdZxwUVvO+hWp2arhJtgnS4p8Mhae9e0lCsQboJ1BuBbE0JIleGG5OcFhf4arCMAz5sSQjYdbgA8CdZJnucnALzwnyqA777wXfyPqCRJtnwdxjX4QvJZ6/4IR0RERERERERERERERERERERERMwS/wGXExjFUxBvVgAAAABJRU5ErkJggg=="
                />
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="backgroundImageRightController">
        <div className="backgroundImageRightZoomControls">
          <div
            className="backgroundImageRightZoomInController"
            onClick={handleZoomInClick}
          >
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none">
              <rect
                x="0.333496"
                y="0.952148"
                width="13.619"
                height="13.619"
                fill="url(#pattern0_1370_276)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_276"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_276"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_276"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </div>
          <div
            className="backgroundImageRightZoomOutController"
            onClick={handleZoomOutClick}
          >
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect
                x="0.571289"
                y="0.952148"
                width="13.619"
                height="13.619"
                fill="url(#pattern0_1370_277)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_277"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_277"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_277"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,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"
                />
              </defs>
            </svg>
          </div>
        </div>
        <div className="backgroundImageRightAdjustImageControls">
          <div
            className="backgroundImageRightAdjustImageWidth"
            onClick={handleFitWidthClick}
          >
            <svg width="15" height="14" viewBox="0 0 15 14" fill="none">
              <rect
                x="0.619141"
                y="0.380859"
                width="13.619"
                height="13.619"
                fill="url(#pattern0_1370_293)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_293"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_293"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_293"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClklEQVR4nO2cz04bMRCHTQ9FSH2g3CLNXPICeZ7cylJVEEEl4ELfgiciLUi0RSDEcdFQH1Cwd23JGXuS3yf5shppZr7sH/B67RwAAAAAAAAAAAAAAGDLWCwWn9wOsdDudzKZHDDzDyJ6kMHMZ3IsFj+fzz8z8xER/SKiFTN3csxKfG6/xWDmJTP37wcRHQ/Ed+vxcsxQfFa/xWDm20Diu1i8nDn8sbHfVuJz+y1GoMi3EYv3l2e/Nm6sxOf2W4zcxKFLlYgODcXbEO0fPp2cSRkPq2bizYi2DkO0DhCtBEQrAdFKQLQSEK0ERCsB0UpAtBIQrQREKwHRSkC0EhCthBnRs9lsn5m/E9EfInomokuVl5sRJLfU4Gu5J6JvUqNp0V7ydeCNxqWrhOQO1H8dk9286Jhk/j8eXR32mPkpUlNQdtOiRyT3sj5i44XG63+M1RWS3azoMcmstS4iXv/JUG3rspsUnSKZB+6HGuTW2JzoxAZ6Q+NNdnOiI0utTA8iOmxOdGSplelBAz1VEy3r17ZQ9KpF0dt46/janGg8DAsz9Avjz7uCjF1KibKXJWvKrP/M/D8sGbKfZN7BVfgORWbtUiWn9rsRUhOPyH6p8bGR5JTcqZJNiB6RfeUqwcw/UyWbEf1O9tJPT8rZdDWdTr+4SkhuL/vF13RifuJ/jb0a9+UBkmqxKNokEK0ERCsB0UpAtBIQrQREKwHRSkC0EhCtBEQrAdFKQLQSEK2EGdGt7fo1z4w3I7rBXb+6zHgbordgl7C+luh/gcR/Y/GhZVVEtLISn9tvMWRXw0Chp4Z2/eoy47P6LYbfQvLCf9UkayTOE7bM7FrZ9Ss3PrffTdDay9ZNs2v9AgAAAAAAAAAAAADgdoNX2Ew3LnErmG0AAAAASUVORK5CYII="
                />
              </defs>
            </svg>
          </div>
          <div
            className="backgroundImageRightAdjustImageHeight"
            onClick={handleFitHeightClick}
          >
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <rect
                x="0.571289"
                y="14.2861"
                width="13.619"
                height="13.619"
                transform="rotate(-90 0.571289 14.2861)"
                fill="url(#pattern0_1370_280)"
              />
              <defs>
                <pattern
                  id="pattern0_1370_280"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlinkHref="#image0_1370_280"
                    transform="scale(0.0111111)"
                  />
                </pattern>
                <image
                  id="image0_1370_280"
                  width="90"
                  height="90"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClklEQVR4nO2cz04bMRCHTQ9FSH2g3CLNXPICeZ7cylJVEEEl4ELfgiciLUi0RSDEcdFQH1Cwd23JGXuS3yf5shppZr7sH/B67RwAAAAAAAAAAAAAAGDLWCwWn9wOsdDudzKZHDDzDyJ6kMHMZ3IsFj+fzz8z8xER/SKiFTN3csxKfG6/xWDmJTP37wcRHQ/Ed+vxcsxQfFa/xWDm20Diu1i8nDn8sbHfVuJz+y1GoMi3EYv3l2e/Nm6sxOf2W4zcxKFLlYgODcXbEO0fPp2cSRkPq2bizYi2DkO0DhCtBEQrAdFKQLQSEK0ERCsB0UpAtBIQrQREKwHRSkC0EhCthBnRs9lsn5m/E9EfInomokuVl5sRJLfU4Gu5J6JvUqNp0V7ydeCNxqWrhOQO1H8dk9286Jhk/j8eXR32mPkpUlNQdtOiRyT3sj5i44XG63+M1RWS3azoMcmstS4iXv/JUG3rspsUnSKZB+6HGuTW2JzoxAZ6Q+NNdnOiI0utTA8iOmxOdGSplelBAz1VEy3r17ZQ9KpF0dt46/janGg8DAsz9Avjz7uCjF1KibKXJWvKrP/M/D8sGbKfZN7BVfgORWbtUiWn9rsRUhOPyH6p8bGR5JTcqZJNiB6RfeUqwcw/UyWbEf1O9tJPT8rZdDWdTr+4SkhuL/vF13RifuJ/jb0a9+UBkmqxKNokEK0ERCsB0UpAtBIQrQREKwHRSkC0EhCtBEQrAdFKQLQSEK2EGdGt7fo1z4w3I7rBXb+6zHgbordgl7C+luh/gcR/Y/GhZVVEtLISn9tvMWRXw0Chp4Z2/eoy47P6LYbfQvLCf9UkayTOE7bM7FrZ9Ss3PrffTdDay9ZNs2v9AgAAAAAAAAAAAADgdoNX2Ew3LnErmG0AAAAASUVORK5CYII="
                />
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundImageController;
